export enum DealersRoutes {
  CreateOne = 'create-one',
  GetAll = 'get-all',
  UpdateOne = 'update-one',
}
